<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="workshop.pkId ? '编辑' : '新建'"
      width="600px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="workshop"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item v-if="workshop.pkId" label="车间编号">
        <el-input v-model="workshop.workshopNo" disabled/>
      </el-form-item>
      <el-form-item label="车间名称" prop="workshopName">
        <el-input v-model="workshop.workshopName" placeholder="请输入车间名称"/>
      </el-form-item>
      <el-form-item label="所属工厂" prop="factoryName">
        <el-input v-model="workshop.factoryName" placeholder="请选择工厂" readonly>
          <el-button slot="append" @click="$refs.selectFactory.open()">选择</el-button>
        </el-input>
        <factory-select ref="selectFactory" @select="selectFactory"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import FactorySelect from "@/views/information/Factory/FactorySelect";
  export default {
    name: "WorkshopEdit",
    components: { FactorySelect },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        workshop: {
          pkId: 0,
          workshopNo: "",
          workshopName: "",
          factoryName: "",
          factoryId: "",
        },
        ruleValidate: {
          workshopName: { required: true, message: "请输入车间名称", trigger: "blur" },
          factoryName: { required: true, message: "请选择所属工厂", trigger: "change" },
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.workshop.pkId = row.pkid;
          this.getData();
        }
      },

      // 根据车间Id查看详情
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `workshops/${this.workshop.pkId}`)
          .then((resp) => {
            this.contentLoading = false;
            if (resp.success) {
              this.workshop = Object.assign(this.workshop, resp.data);
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 选择工厂
      selectFactory(row) {
        this.workshop.factoryId = row.pkId;
        this.workshop.factoryName = row.factoryName;
      },

      // 编辑、新建
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "workshops", this.workshop)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.workshop.pkId) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
